/*
 * Exports
 */
export { default } from './components/PhysicalHoldsWorkflowView.component';



// WEBPACK FOOTER //
// ./app/components/shared/ItemTransactions/components/physical-holds-workflow-view/index.js